import axios from 'axios';

// 取消ETC充值
export const revokeEtcCharge = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/etcEntityBO.ajax?cmd=revokeEtcCharge',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// Etc充值记录列表
export const queryEtcEntityPage = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/etcEntityBO.ajax?cmd=queryEtcEntityPage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// Etc充值记录核销按钮
export const batchVerificationEtc = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/etcEntityBO.ajax?cmd=batchVerificationEtc',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});


// 后服管理-油管理-主卡管理-列表-申请充值-详情
export const toParentRecharge = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=toParentRecharge',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-油管理-主卡管理-列表-主卡明细
export const queryOilMasterCardAccountDetailsList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardAccountDetailsBO.ajax?cmd=queryOilMasterCardAccountDetailsList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-油管理-主卡管理-列表-子卡明细
export const queryOilDaughterCardAccountDetailsList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardAccountDetailsBO.ajax?cmd=queryOilDaughterCardAccountDetailsList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-油管理-主卡管理-列表-删除
export const removeParentOil = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=removeParentOil',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-油管理-主卡管理-列表-申请充值
export const doOilCardRecharge = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=doOilCardRecharge',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 保存（新增修改）油卡信息
export const saveOrUpdateOilCard = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=save',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-油管理-主卡管理-列表
export const doQueryParent = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=doQueryParent',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 服务商弹窗列表
export const servicerDialogList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleFeePaymentParBO.ajax?cmd=doQueryService',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 服务商下拉列表
export const servicerSelectList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceInfoBO.ajax?cmd=getServiceInfoList',
    method: 'post',
    data: {
      serviceType: -1,
      ...data,
    },
  }).then(async (res) => {
    const result = res.items.map((item) => ({
      label: item.serviceName,
      value: item.serviceUserId,
    }));
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});
// 服务商 - 绑定账户信息
export const servicerBindBankcard = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/pinganBO.ajax?cmd=queryBankInfos',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 服务商列表
export const servicerList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceInfoBO.ajax?cmd=queryServiceInfoPage',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 服务商账号检查
export const servicerCheck = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceInfoBO.ajax?cmd=checkRegisterService',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 服务商 - 修改
export const servicerEdit = async (data) => new Promise((resolve, reject) => {
  let url = '/serviceInfoBO.ajax?cmd=doSaveService';
  if (data.serviceUserId) {
    url = '/serviceInfoBO.ajax?cmd=modifyService';
  } else if (data.hadServer) {
    url = '/serviceInfoBO.ajax?cmd=applyService';
  }
  axios({
    url,
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 服务商 - 详情
export const servicerDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceInfoBO.ajax?cmd=seeServiceInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    if (data.isEdit === 1) {
      resolve(res.serviceData);
    } else {
      resolve(res);
    }
  }).catch((err) => {
    reject(err);
  });
});
// 服务商 - 删除
export const servicerDel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceInfoBO.ajax?cmd=delService',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 服务商管理-确认
export const serviceConfirm = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceInfoBO.ajax?cmd=updateServiceInfoType',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 服务商 - 历史记录
export const servicerRecordList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceInfoBO.ajax?cmd=queryTenantServiceHis',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 站点弹窗列表
export const siteDialogList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/repairPreApplyBO.ajax?cmd=doQueryServiceProduct',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 站点列表
export const siteList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductBO.ajax?cmd=queryServiceProductList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 站点 - 修改产品
export const siteEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductBO.ajax?cmd=saveProduct',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 站点 - 产品详情
export const siteDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductBO.ajax?cmd=getTenantProduct',
    method: 'post',
    data,
  }).then(async (res) => {
    if (data.isEdit === 1) {
      resolve(res.productData);
    } else {
      resolve(res);
    }
  }).catch((err) => {
    reject(err);
  });
});
// 站点 - 产品二维码
export const siteQrcode = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductBO.ajax?cmd=orCodeByOilInd',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 站点交易记录列表
export const siteTransRecordList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductBO.ajax?cmd=queryOilTransaction',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 站点交易记录汇总
export const siteTransRecordTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductBO.ajax?cmd=totalOilTransaction',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 站点记录列表
export const siteRecordList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductBO.ajax?cmd=queryProductHis',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 获取申请卡信息
export const applyCardDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductOilsBO.ajax?cmd=getProductInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 找油账户信息
export const oilComponyAccount = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/financePublicBO.ajax?cmd=getTenantOilAccountBalance',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 找油账户流水
export const oilAccountRecordList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilRechargeAccountBO.ajax?cmd=getOilRechargeAccountDetailsFlow',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 找油账户流水汇总
export const oilAccountRecordTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilRechargeAccountBO.ajax?cmd=sumOilRechargeAccountDetailsFlow',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 找油账户详情列表总览
export const oilAccountDetailListTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilRechargeAccountBO.ajax?cmd=getOilRechargeAccountDetailsSum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 找油账户详情列表
export const oilAccountDetailList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilRechargeAccountBO.ajax?cmd=getOilRechargeAccountDetails',
    method: 'post',
    data,
  }).then(async (res) => {
    if (data.page === 1) {
      oilAccountDetailList.totalRes = await oilAccountDetailListTotal(data);
    }
    res.items = [
      {
        acctName: '合计',
        accountBalanceDouble: oilAccountDetailList.totalRes.account_balance,
        distributedAmountDouble: oilAccountDetailList.totalRes.distributed_amount,
      },
      ...res.items,
    ];
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 授信额度列表
export const oilAccountSiteDetailList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/accountBO.ajax?cmd=queryCreditLineDetails',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡详情
export const oilCardDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/voucherInfoBO.ajax?cmd=getServiceCard',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡优惠券列表
export const oilCardCouponList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/voucherInfoBO.ajax?cmd=getVoucherInfoByProductId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡充值
export const oilCardRecharge = async (data) => new Promise((resolve, reject) => {
  let url = '/voucherInfoBO.ajax?cmd=rechargeOilCard';
  if (data.oilCardList) {
    url = '/voucherInfoBO.ajax?cmd=doBatchRechargeOilCard';
  }
  axios({
    url,
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 申请油卡
export const oilCardApply = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCard/serviceProductOilsBO.ajax?cmd=doSaveApplyOilCard',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡列表
export const oilList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡列表
export const oilRecharge = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=saveOilCharge',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油卡 - 修改
export const oilEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=save',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡 - 详情
export const oilDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=getOilCardManagement',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡 - 更新余额
export const oilUpdateBanlance = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=updOilCardBlace',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡 - 导入
export const oilImport = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=saveExcelData&code=1429339322',
    method: 'post',
    headers: {
      isForm: true,
    },
    data: {
      oilCardFile: data.file,
    },
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油卡 - 使用日志
export const oilUseRecordList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardLogBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油卡 - 消费记录列表
export const oilConsumeList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/voucherInfoBO.ajax?cmd=getOilConsumeRecords',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡 - 总览数值
export const oilConsumeTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/voucherInfoBO.ajax?cmd=sumOilConsumeRecords',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油卡 - 充值核销列表
export const oilRechargeList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=getOilEntitys',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡 - 充值核销列表 - 撤销
export const oilRechargeCancel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=revokeOilCharge',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// 油卡 - 充值核销列表 - 核销
export const oilRechargeWriteOff = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=batchVerificatOrder',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油卡 - 充值核销列表 - 切换卡号
export const oilRechargeChangeCardNo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=updateOilCarNum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// etc订单列表
export const etcOrderList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmEtcInfoBO.ajax?cmd=queryOrderInfoEtc',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 预付费ETC卡充值信息
export const toEtcCardRecharge = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/etcMaintainBO.ajax?cmd=toEtcCardRecharge',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// etc卡管理列表
export const etcManageList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/etcMaintainBO.ajax?cmd=queryEtc',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// etc导入
export const etcImport = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/etcMaintainBO.ajax?cmd=saveExcelData',
    method: 'post',
    headers: {
      isForm: true,
      urlAddCodeAndSign: true,
    },
    data: {
      etcCardFile: data.file,
    },
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// etc卡管理 - 详情
export const etcManageDetail = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/etcMaintainBO.ajax?cmd=getEtc',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// etc卡管理 - 修改
export const etcManageEdit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/etcMaintainBO.ajax?cmd=saveOrUpdateEtc',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 预付费ETC充值
export const etcCardRecharge = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/etcMaintainBO.ajax?cmd=etcCardRecharge',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// etc卡消费列表
export const etcConsumeList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmEtcInfoBO.ajax?cmd=doQuery',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// etc 选择匹配订单列表
export const etcMatchOrderList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmEtcInfoBO.ajax?cmd=getOrderListByManualSync',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// etc 选择匹配
export const etcMatch = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmEtcInfoBO.ajax?cmd=manualSyncOrderByEtc',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// etc 上报费用
export const etcPostCost = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmEtcInfoBO.ajax?cmd=coverEtc',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
// etc 反写订单
export const etcBackOrder = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmEtcInfoBO.ajax?cmd=batchSyncOrderByEtc',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// etc 反写订单
export const etcDeduction = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmEtcInfoBO.ajax?cmd=batchDeductionAccountByEtc',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油卡管理-列表-点击回收
export const reclaim = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilCardManagementBO.ajax?cmd=reclaim',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油气管理 - 加气标签列表
export const deviceLabelList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/api/vehicleDataInfoBO.ajax?cmd=doQueryVehicleLabel',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油气管理 - 加气消费明细表
export const consumeDetailsList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/api/vehicleDataInfoBO.ajax?cmd=doQueryRefuelRecord',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油气管理 - 加气消费明细表 -总览数值
export const gasConsumeTotal = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/api/vehicleDataInfoBO.ajax?cmd=findVehicleRefuelRecordSum',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 油气耗 - 车辆列表
export const vehicleList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilGasStatisticsBO.ajax?cmd=getVehicleByOilOrGas',
    method: 'post',
    data,
  }).then(async (res) => {
    let result = [];
    const children = res.child && res.child.map((item, index) => ({
      label: item.name,
      id: 2 + index,
      children: item.plateNumbers.map((itemChild, itemIndex) => ({
        label: itemChild,
        id: res.child.length + 2 + itemIndex,
      })),
    }));
    result.push({
      label: res.name,
      id: 1,
      children: children,
    });
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理--报警列表
export const getAlarmList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/carAlarmBO.ajax?cmd=getCarAlarmList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});


// 油气耗 -按日期查询
export const getOilAndGasConsumptionByDate = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilGasStatisticsBO.ajax?cmd=getOilAndGasConsumptionByDate',
    method: 'post',
    data,
  }).then(async (res) => {
    let result = [];
    if (res) {
      result.items = res.dataList;
      // result.total = res.page.totalNumberOfElements;
      result.option = res.option;
    }
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 油气耗 -按车辆查询
export const getOilGasStatisticListByCarNo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/oilGasStatisticsBO.ajax?cmd=getOilGasStatisticListByCarNo',
    method: 'post',
    data,
  }).then(async (res) => {
    let result = [];
    if (res && res.page) {
      result.items = res.page.thisPageElements;
      result.total = res.page.totalNumberOfElements;
      result.option = res.option;
    }
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 库存管理--库存列表
export const getInventoryListApi = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=getInventoryList', method: 'post', data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理 -- 出入库明细列表查询
export const getInventoryDetailsList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=doQueryInventoryInAndOutDetails',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理 -- 出入库列表 -- 新增出入库明细
export const createInventoryInAndOutDetails = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=createInventoryInAndOutDetails',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理 -- 配件名称枚举查询
export const getAccessoryNameList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=getAccessoryNameList',
    method: 'post',
    data,
  }).then(async (res) => {
    let result = [];
    if (res.items) {
      result = res.items.map((item, index) => ({
        label: item.accessoryName,
        value: index + 1,
      }));
    }
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理 -- 配件型号枚举查询
export const getAccessoryModelList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=getAccessoryModelList',
    method: 'post',
    data,
  }).then(async (res) => {
    let result = [];
    if (res.items) {
      result = res.items.map((item) => ({
        label: item.accessoryModel,
        value: item.id,
      }));
    }
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理  -- 配件名称查询 （联动配型型号和入库单价）
export const getInventoryList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=getUnitPriceList',
    method: 'post',
    data,
  }).then(async (res) => {
    let result = [];
    if (res.items) {
      result = res.items.map((item) => ({
        label: item.unitPriceDouble,
        value: item.id,
      }));
      if (data.unitPrice) {
        result = res.items;
      }
    }
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});


// 后服管理-- 库存管理  -- 配件类型列表查询
export const getInventoryModelList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=getInventoryModelList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理 -- 出入库明细列表(出库总额、入库总额)
export const getInventoryInAndOutTotalFee = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=getInventoryInAndOutTotalFee',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理  -- 出入库明细删除
export const removeInventoryInAndOutDetails = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=deleteInventoryInAndOutDetails',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理  -- 配件类型 -- 新增配件类型
export const saveOrUpdateInventoryModel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=saveOrUpdateInventoryModel',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理  -- 配件类型 -- 查看配件类型详情
export const getAccessoryModelById = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=getAccessoryModelById',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 后服管理-- 库存管理  -- 配件类型 -- 删除配件类型
export const deleteInventoryModelById = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/inventoryManagementBO.ajax?cmd=deleteInventoryModelById',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});


